"use client";
import { ParallaxProvider } from "react-scroll-parallax";
import { ReactNode } from "react";

type LandingWrapperProps = {
	children: ReactNode;
};

export default function LandingWrapper({ children }: LandingWrapperProps) {
	return (
		<ParallaxProvider>
			<div className="flex min-h-dvh w-full flex-col justify-between">
				<main className="flex flex-1 flex-col">{children}</main>
			</div>
		</ParallaxProvider>
	);
}
